var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJcbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 1590,
    viewBox: "0 0 2500 1590",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2098_2652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2500.3 1268.81C2500.3 1445.38 2326.08 1589.15 2112.12 1589.15H0V320.424C0 143.862 174.227 0.0903625 388.189 0.0903625H2500.3V1268.81Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1812.57 943.435H1973.04C1977.63 943.435 1988.32 942.174 1992.91 942.174C2023.47 937.13 2049.46 914.429 2049.46 882.9C2049.46 852.632 2023.47 829.931 1992.91 823.625C1988.32 822.364 1979.15 822.364 1973.04 822.364H1812.57V943.435Z",
    fill: "url(#paint0_linear_2098_2652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1954.7 107.289C1801.87 107.289 1676.55 209.442 1676.55 336.819V575.178H2069.32C2078.49 575.178 2089.19 575.178 2096.83 576.439C2185.48 580.222 2251.19 618.057 2251.19 683.637C2251.19 735.344 2206.87 779.485 2124.34 788.313V790.835C2214.51 795.88 2283.29 837.498 2283.29 901.817C2283.29 971.181 2206.87 1016.58 2106 1016.58H1675.02V1483.21H2083.08C2235.91 1483.21 2361.23 1381.06 2361.23 1253.68V107.289H1954.7Z",
    fill: "url(#paint1_linear_2098_2652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2029.59 698.771C2029.59 668.503 2003.61 648.325 1973.04 644.541C1969.98 644.541 1962.34 643.28 1957.76 643.28H1812.57V754.262H1957.76C1962.34 754.262 1971.51 754.262 1973.04 753.001C2003.61 749.217 2029.59 729.039 2029.59 698.771Z",
    fill: "url(#paint2_linear_2098_2652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.226 107.289C264.396 107.289 139.075 209.442 139.075 336.819V903.078C217.019 934.607 298.019 954.786 379.019 954.786C475.302 954.786 527.264 906.862 527.264 841.282V573.917H765.68V840.021C765.68 943.435 687.736 1027.93 423.34 1027.93C262.868 1027.93 137.547 998.926 137.547 998.926V1481.95H545.604C698.434 1481.95 823.755 1379.8 823.755 1252.42V107.289H417.226Z",
    fill: "url(#paint3_linear_2098_2652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.96 107.289C1033.13 107.289 907.812 209.442 907.812 336.819V636.974C978.114 587.789 1100.38 556.26 1297.53 563.827C1402.98 567.611 1516.08 591.573 1516.08 591.573V688.682C1459.53 664.72 1392.28 643.28 1305.17 638.235C1155.4 629.407 1065.23 689.943 1065.23 795.88C1065.23 903.078 1155.4 963.614 1305.17 953.525C1392.28 948.48 1459.53 925.779 1516.08 903.078V1000.19C1516.08 1000.19 1404.51 1024.15 1297.53 1027.93C1100.38 1035.5 978.114 1003.97 907.812 954.786V1484.47H1315.87C1468.7 1484.47 1594.02 1382.32 1594.02 1254.94V107.289H1185.96Z",
    fill: "url(#paint4_linear_2098_2652)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2098_2652",
    x1: 1676.29,
    y1: 883.051,
    x2: 2363.08,
    y2: 883.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2098_2652",
    x1: 1676.27,
    y1: 794.695,
    x2: 2363.11,
    y2: 794.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2098_2652",
    x1: 1676.27,
    y1: 698.607,
    x2: 2363.08,
    y2: 698.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2098_2652",
    x1: 138.754,
    y1: 794.695,
    x2: 836.165,
    y2: 794.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2098_2652",
    x1: 903.854,
    y1: 794.695,
    x2: 1581.21,
    y2: 794.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2098_2652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2500,
    height: 1588.8,
    fill: "white",
    transform: "translate(0 0.480103)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcbIcon);
export default __webpack_public_path__ + "static/media/jcb-icon.ea8728d33c0c389493c02d31371a1a56.svg";
export { ForwardRef as ReactComponent };